import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';

//! TODO: Remove Styles Imports Once Will Be Prepared Styles From Global Repo
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { LeftArrowButton, RightArrowButton } from "./SliderArrows";
import { swiperSliderDefaultProps } from './constants';

export const Slider = ({
    SlideItem,
    spaceBetween = 0,
    slidesPerView = 7,
    slidesPerGroup = 7,
    slideItemConfigurations,
    leftArrowClassName,
    rightArrowClassName,
    isBulletsOutsideSlides = false,
    isArrowsHidden = false,
}) => {
    return (
        <div className='swiper-slider-wrapper'>
            <Swiper
                {...swiperSliderDefaultProps}
                spaceBetween={spaceBetween}
                slidesPerView={slidesPerView}
                slidesPerGroup={slidesPerGroup}
                modules={[Pagination, Navigation, A11y, Keyboard]}
                className={
                    isBulletsOutsideSlides
                        ? "swiper-bullets-outside-slides"
                        : ""
                }
            >
                {slideItemConfigurations?.map((configOptions, index) => (
                    <SwiperSlide key={`swiper-slide-${index}`}>
                        <SlideItem {...configOptions} />
                    </SwiperSlide>
                ))}
            </Swiper>
            { !isArrowsHidden && (
                <LeftArrowButton
                    className={leftArrowClassName}
                    shouldCenterArrows={isBulletsOutsideSlides}
                />
            )}
            {!isArrowsHidden && (
                <RightArrowButton
                    className={rightArrowClassName}
                    shouldCenterArrows={isBulletsOutsideSlides}
                />
            )}
        </div>
    )
}